import {executeCrudEpic, Type} from 'lib/crud'
import {dao, name} from 'lib/roles'
import {combineEpics} from 'redux-observable'

export const rolesEpics = combineEpics(
    executeCrudEpic(name, Type.LIST)(dao.list),
    executeCrudEpic(name, Type.GET)(dao.get),
)